import React, { useEffect } from 'react'
import VLILogo from "./Assets/InvoiceLogo.png";
import InstituteImage from "./Assets/InstituteImage.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetInvoicePaymentInstallmentsData } from '../../Actions/CourseA';
import { GetLocalStorage } from '../../Helpers/LocalStorage/LocalStorage';
import { BaseUrl } from '../../Actions/Base';
import PayPalImage from "./Assets/paypalPaymentimg.png";
import CreditCard from "./Assets/CreditCardMethod.svg";
import GooglePay from "./Assets/GooglePayMethod.png";
import ApplePay from "./Assets/ApplePayMethod.png";
import BankTransfer from "./Assets/BankTransferMethod.svg";
import Visa from "./Assets/visa.svg";
import mastercard from "./Assets/mastercard.svg";
import americanexpress from "./Assets/americanexpress.svg";
import UnknownCardImage from "./Assets/unknown.svg";
import './PaymentInvoice.css';

const PaymentInstallmentsInvoice = () => {
    const { paymentId } = useParams();
    console.log("paymentId in PaymentInstallmentsInvoice is:",paymentId)
    const Dispatch = useDispatch();
    const UserId = GetLocalStorage("UserInfo")?.UserId;
    console.log("UserId in PaymentInstallmentsInvoice is:",UserId)


    let ButtonStyle = `text-white text-center w-fit min-w-[250px] py-3 rounded-[9px] whitespace-nowrap border-none px-4 cursor-pointer SemiBold
    text-3xs md:text-3xs lg:text-2xs xl:text-xs 
    `
    const { coursePaymentInstallmentInvoiceData } = useSelector(
        (Store) => Store.CourseReducer
      );

    console.log("coursePaymentInstallmentInvoiceData in PaymentInstallmentsInvoice is:",coursePaymentInstallmentInvoiceData)

    useEffect(() => {
        if(paymentId){
        Dispatch(GetInvoicePaymentInstallmentsData(paymentId, UserId));
        }
    }, [Dispatch, paymentId, UserId]);

    // Calculate discounted subtotal
    const discount = coursePaymentInstallmentInvoiceData?.coursePackage?.AddDiscount || 0;
    const originalAmount = coursePaymentInstallmentInvoiceData?.installments?.Amount ?? 0;
    const subtotal = originalAmount * (1 - discount / 100); // Apply discount
    const tax = subtotal * 0.13; // 13% tax calculation
    const grandTotal = subtotal + tax;


    const maskedEmail = (email) => {
        if (!email) return "";
        const parts = email.split("@");
        return parts[0].substring(0, 3) + "***@" + parts[1]; 
    };
    
    const maskedCardNumber = (cardNumber) => {
        if (!cardNumber) return "";
        return "**** **** **** " + cardNumber.slice(-4);
    };

    const payment = coursePaymentInstallmentInvoiceData?.paymentMethod;

    let paymentMethodDisplay = "";
    let paymentMethodText = "";
    let paymentMethodImage = "";

    if (payment?.PaymentType === "paypal") {
        paymentMethodDisplay = maskedEmail(payment?.PaypalEmail);
        paymentMethodText = "Paypal ID";
        paymentMethodImage = PayPalImage;
    } else if (payment?.PaymentType === "googlepay") {
        paymentMethodDisplay = maskedEmail(payment?.GooglePayEmail);
        paymentMethodText = "googlepay ID";
        paymentMethodImage = GooglePay;
    } else if (payment?.PaymentType === "applepay") {
        paymentMethodDisplay = maskedEmail(payment?.ApplePayEmail);
        paymentMethodText = "applepay ID";
        paymentMethodImage = ApplePay;
    } else if (payment?.PaymentType === "creditCard") {
        paymentMethodDisplay = maskedCardNumber(payment?.CreditCardCardNumber);
        paymentMethodText = "creditcard No";

        // Now check the brand
        const brand = payment?.CreditCardBrand?.toLowerCase();  // Example: "visa", "mastercard", "amex"

        if (brand === "visa") {
            paymentMethodImage = Visa;
        } else if (brand === "mastercard") {
            paymentMethodImage = mastercard;
        } else if (brand === "amex" || brand === "american express") {
            paymentMethodImage = americanexpress;
        } else {
            paymentMethodImage = UnknownCardImage; // fallback image if brand not matched
        }

        // paymentMethodImage = CreditCard;
    } else if (payment?.PaymentType === "BankAccount") {
        paymentMethodDisplay = maskedCardNumber(payment?.BankAccountAccountNumber);
        paymentMethodText = "BankAccount No";
        paymentMethodImage = BankTransfer;
    }

    const paymentsData = {
        paymentMethod: paymentMethodDisplay,
        paymentMethodImgs: paymentMethodImage,
        paymentMethodHeading: paymentMethodText,
    };

    console.log(paymentsData);

    const downloadInvoice = async () => {
        const input = document.getElementById('downloadContent'); // Ensure this ID matches the content you want
    
        // Convert to canvas
        const canvas = await html2canvas(input, { scale: 2 });
    
        // Get the image data
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
    
        // Initialize PDF
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
    
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = pdfWidth - 20; // Adjust margins
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
    
        let y = 5; // Start position

        pdf.addImage(imgData, 'JPEG', 10, y, imgWidth, imgHeight);
    
        // if (imgHeight <= pdfHeight - 20) {
        //     // **If content fits within one page, just add it normally**
        //     pdf.addImage(imgData, 'JPEG', 10, y, imgWidth, imgHeight);
        // } else {
        //     // **🛠 If content is too long, handle pagination**
        //     let currentY = y;
        //     let remainingHeight = imgHeight;
        //     let page = 1;
    
        //     while (remainingHeight > 0) {
        //         const sliceHeight = Math.min(remainingHeight, pdfHeight - 20);
    
        //         // Crop and add part of the image
        //         pdf.addImage(imgData, 'JPEG', 10, currentY, imgWidth, sliceHeight);
    
        //         remainingHeight -= sliceHeight;
    
        //         if (remainingHeight > 0) {
        //             pdf.addPage();
        //             currentY = 10; // Reset Y for new page
        //             page++;
        //         }
        //     }
        // }
    
        pdf.save('Payment-Invoice.pdf');
    };

    const downloadMobileInvoice = async () => {
        const input = document.getElementById('downloadContent');
    
        const canvas = await html2canvas(input, { scale: 2 });
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
    
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
    
        const imgProps = pdf.getImageProperties(imgData);
        const imgWidth = pdfWidth;
        const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
    
        let heightLeft = imgHeight;
        let position = 0;
    
        while (heightLeft > 0) {
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;
            position -= pdfHeight;
    
            if (heightLeft > 0) {
                pdf.addPage();
            }
        }
    
        pdf.save('Payment-Invoice.pdf');
    };
    
    
    return(
        <div className='mt-[100px] lg:mt-[150px] overflow-x-hidden'>
             <button onClick={downloadInvoice} className={`${ButtonStyle} hidden lg:block text-white bg-[#A1A3EF] ml-[150px]`}>
                Download Invoice
            </button>
      
            <div className='mt-[50px] w-full flex justify-center items-center lg:pb-[200px]'>
                <div className='w-full lg:w-[80%] relative flex flex-col bg-[#F1F2F2] font-arial' id="downloadContent">
                    <div className='w-full h-[170px] bg-[#8B55FF] flex lg:items-center justify-center lg:justify-end'>
                            <p className="text-[#FFFFFF] text-[44px] lg:text-[72px] font-bold mr-[50px] font-arial mt-[10px] lg:mt-0">INVOICE</p>
                    </div>
                    <div className='absolute h-[150px] lg:h-[220px] w-[220px] lg:w-[400px] bg-[#FFFFFFE6] top-[70px] lg:top-0 left-[70px] lg:left-[50px] flex justify-center items-center'>
                        <img src={VLILogo} alt="VLILogo"  className='w-[200px] lg:w-[350px]'/>
                    </div>
                    <div className='h-[20px] w-full bg-[#5DDEE7]'> </div>

                    <div className='flex w-full justify-center items-center'>
                        <div className='flex flex-col w-[100%] lg:w-[90%] justify-center items-center'>

                            <div className='w-[90%] lg:w-full  flex flex-col gap-[30px] lg:gap-0 lg:flex-row lg:h-[180px] justify-between mt-[50px] lg:mt-[80px]'>
                                    <div className='flex flex-col h-full justify-between'>
                                        <div>
                                            <p className="text-[#303643] text-[26px] lg:text-[28px] font-arial font-bold">To: {coursePaymentInstallmentInvoiceData?.student?.FirstName} {coursePaymentInstallmentInvoiceData?.student?.LastName}</p>
                                        </div>

                                        <div className='flex flex-col gap-[5px]'>
                                            <p className="text-[#39404E] text-[20px] font-arial w-[330px] mt-[30px] lg:mt-0"><span className="font-bold text-[#303643]">Address:</span> {coursePaymentInstallmentInvoiceData?.studentInfo?.Address}</p>
                                            <p className="text-[#39404E] text-[20px] font-arial"><span className="font-bold text-[#303643]">Phone:</span> +{coursePaymentInstallmentInvoiceData?.student?.PhoneNumber}</p>
                                            <p className="text-[#39404E] text-[20px] font-arial"><span className="font-bold text-[#303643]">Email:</span> {coursePaymentInstallmentInvoiceData?.student?.Email}</p>
                                        </div>
                                    </div>

                                    <div className='flex gap-[10px]'>
                                            <div className='hidden lg:block h-[180px] w-[2px] bg-[#5DDEE7]'></div> 
                                            <div className='flex flex-col gap-[15px]'>
                                                <p className="text-[#303643] text-[28px] font-arial font-bold">Invoice Details</p>
                                                <p className="text-[#39404E] text-[20px] font-arial mt-[20px]"><span className="font-bold text-[#303643]">Invoice Date:</span> {new Date(coursePaymentInstallmentInvoiceData?.coursePayment?.PaymentDate).toLocaleDateString()}</p>
                                                <p className="text-[#39404E] text-[20px] font-arial"><span className="font-bold text-[#303643]">Invoice No:</span> {coursePaymentInstallmentInvoiceData?.coursePayment?.InvoiceId}</p>
                                            </div>
                                    </div>

                                    <div className='flex flex-col gap-[10px] flex-end'>
                                        <div className='flex w-full lg:justify-end'>
                                        <p className="text-[#303643] text-[27px] font-bold font-arial">Amount Paid</p>
                                        </div>
                                        <p className="text-[#303643] text-[27px] font-bold font-arial">CAD ${grandTotal.toFixed(2)}</p>
                                    </div>
                            </div>

                            <div className='mt-[40px] lg:mt-[60px] w-full'>
                                <div className="w-full overflow-x-auto scrollbar-hidden">
                                    <table className="w-full min-w-[800px] border-collapse ">
                                        <thead>
                                            <tr className="text-[#F9FAFC] h-[60px] font-arial"
                                            style={{
                                                    background: "linear-gradient(90deg, #5DDEE7 0%, #8B55FF 100%)",
                                                }}>
                                                <th className="text-[27px] font-bold pl-[20px] text-left font-arial">Description</th>
                                                <th className="text-[27px] font-bold text-center font-arial">Fee</th>
                                                <th className="text-[27px] font-bold text-center font-arial">Discount</th>
                                                <th className="text-[27px] font-bold text-center font-arial">Discounted Fee</th>
                                            </tr>
                                        </thead>
                                        <tbody className="">
                                            <tr className="">
                                                <td className="flex flex-col gap-[10px] pl-[20px] text-left pt-[30px] ">
                                                    <p className="text-[21px] text-[#303643] font-bold font-arial">
                                                    {coursePaymentInstallmentInvoiceData?.course?.CourseName}
                                                    </p>
                                                    <p className="text-[20px] text-[#39404E] font-arial">{coursePaymentInstallmentInvoiceData?.coursePackage?.PackageName}</p>
                                                </td>
                                                <td className="text-[24px] text-[#303643] font-arial text-center pt-[30px]">${coursePaymentInstallmentInvoiceData?.installments?.Amount}</td>
                                                <td className="text-[24px] text-[#303643] font-arial text-center pt-[30px]">{coursePaymentInstallmentInvoiceData?.coursePackage?.AddDiscount || 0}%</td>
                                                <td className="text-[24px] text-[#303643] font-arial text-center pt-[30px]">${(
                                                    coursePaymentInstallmentInvoiceData?.installments?.Amount * 
                                                    (1 - (coursePaymentInstallmentInvoiceData?.coursePackage?.AddDiscount || 0) / 100)
                                                ).toFixed(2)} <sup className="text-[18px] ml-[-7px]">+Tax</sup></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="w-full hidden lg:block h-[80px] bg-[#EAEAEA] mt-[30px]"></div>

                            <div className='w-full flex flex-col lg:flex-row gap-[10px] mt-[40px]'>
                                <div className='w-full lg:w-[60%] h-[200px] flex flex-col gap-[15px] bg-[#5DDEE726] p-[30px]'>
                                    <p className="text-[28px] font-bold text-[#303643] font-arial">
                                    {coursePaymentInstallmentInvoiceData?.course?.CourseName}
                                    </p>
                                    <p className="text-[27px] text-[#303643] font-arial">{coursePaymentInstallmentInvoiceData?.coursePackage?.PackageName}</p>
                                    <p className="text-[27px] text-[#303643] font-arial">Installment No: {coursePaymentInstallmentInvoiceData?.installments?.InstallmentNumber}</p>
                                </div>

                                <div className='w-full lg:w-[40%] h-[200px] flex flex-col gap-[15px] bg-[#8B55FF0D] p-[30px]'>
                                    <div className='w-full flex justify-between'>
                                        <p className="text-[22px] text-[#303643] font-arial">Sub Total</p>
                                        <p className="text-[22px] text-[#303643] font-arial">${subtotal.toFixed(2)}</p>
                                    </div>

                                    <div className='w-full flex justify-between'>
                                        <p className="text-[22px] text-[#303643] font-arial">Tax 13%</p>
                                        <p className="text-[22px] text-[#303643] font-arial">${tax.toFixed(2)}</p>
                                    </div>

                                    <div className='w-full flex justify-between mt-[20px] lg:mt-0'>
                                        <p className="text-[28px] font-bold text-[#303643] font-arial">
                                            Grand Total
                                        </p>
                                        <p className="text-[28px] font-bold text-[#303643] font-arial">${grandTotal.toFixed(2)}</p>
                                    </div>
                                
                                </div>
                            </div>

                            <div className='w-[90%] lg:w-full mt-[40px] flex flex-col gap-[40px] lg:gap-0 lg:flex-row justify-between'>
                                <div className='lg:hidden flex flex-col  items-start gap-[20px]'>
                                    <p className="text-[28px] text-[#39404E] font-bold font-arial">
                                        Payment Method
                                    </p>
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        Thankyou For Your Purchase
                                    </p>
                                    <img src={paymentsData?.paymentMethodImgs} alt="PayPalImage" className="h-[60px]" />
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        <span className="font-bold  text-[22px] text-[#39404E]">{paymentsData?.paymentMethodHeading}:</span> {paymentsData?.paymentMethod}
                                    </p>
                                </div>

                                <div className='flex flex-col gap-[5px]'>
                                    {/* <img src={InstituteImage} alt="InstituteImage" className='w-[200px]' /> */}
                                    <img
                                        className="w-[150px] h-[60px]"
                                        src={
                                            coursePaymentInstallmentInvoiceData
                                                ? `${BaseUrl}/api/vehicletype/image?url=${coursePaymentInstallmentInvoiceData?.institute?.InstituteLogo}`
                                                : null
                                        }
                                        alt="Logo"
                                    />
                                    <p className="text-[28px] text-[#303643] font-arial font-bold mt-[10px]">
                                        Institute Details
                                    </p>
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        <span className="font-bold text-[22px] text-[#39404E]">Name:</span> {coursePaymentInstallmentInvoiceData?.institute?.InstituteName}
                                    </p>
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        <span className="font-bold  text-[22px] text-[#39404E]">Phone:</span> {coursePaymentInstallmentInvoiceData?.instituteOwner?.PhoneNumber}
                                    </p>
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        <span className="font-bold  text-[22px] text-[#39404E]">Email:</span> {coursePaymentInstallmentInvoiceData?.instituteOwner?.Email}
                                    </p>
                                    <p className="text-[20px] text-[#303643] w-[470px] font-arial">
                                        <span className="font-bold  text-[22px] text-[#39404E]">Address:</span> {coursePaymentInstallmentInvoiceData?.institute?.Address}
                                    </p>
                                </div>

                                <div className='hidden lg:flex flex-col  items-start gap-[20px]'>
                                    <p className="text-[28px] text-[#39404E] font-bold font-arial">
                                        Payment Method
                                    </p>
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        Thankyou For Your Purchase
                                    </p>
                                    <img src={paymentsData?.paymentMethodImgs} alt="PayPalImage" className="h-[60px]" />
                                    <p className="text-[20px] text-[#303643] font-arial">
                                        <span className="font-bold  text-[22px] text-[#39404E]">{paymentsData?.paymentMethodHeading}:</span> {paymentsData?.paymentMethod}
                                    </p>
                                </div>
                            </div>

                            <div className='w-[90%] lg:w-full mt-[40px] flex flex-col gap-[20px]'>
                                <p className="text-[28px] text-[#303643] font-bold font-arial">Vehicle Learning Innovation Inc.</p>

                                <div className='flex flex-col lg:flex-row gap-[20px] lg:gap-[30px]'>
                                        <div className='flex flex-col gap-[5px]'>
                                            <p className="text-[20px] text-[#303643] font-arial font-bold">
                                                Phone
                                            </p>
                                            <p className="text-[18px] font-arial text-[#303643]">
                                            +1 647 948 9811
                                            </p>
                                            <hr className='w-[40px] mt-[10px]'></hr>
                                        </div>

                                        <div className='flex flex-col gap-[5px]'>
                                            <p className="text-[20px] text-[#303643] font-arial font-bold">
                                            Email
                                            </p>
                                            <p className="text-[18px] text-[#303643] font-arial">
                                            headoffice@vehiclelearning.com
                                            </p>
                                            <hr className='w-[40px] mt-[10px]'></hr>
                                        </div>

                                        <div className='flex flex-col gap-[5px]'>
                                            <p className="text-[20px] text-[#303643] font-arial font-bold">
                                            Address
                                            </p>
                                            <p className="text-[18px] text-[#303643] font-arial">
                                            1225 Kennedy Rd, Suite 2000, Toronto, M1P 4Y1, ON, Canada.
                                            </p>
                                            <hr className='w-[40px] mt-[10px]'></hr>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='h-[20px] w-full bg-[#8B55FF] mt-[30px]'> </div>
                    <div className='h-[20px] w-full bg-[#5DDEE7]'> </div>

                </div>
            </div>

            <div className='w-[90%] flex justify-end lg:hidden mt-[20px] pb-[100px]'>
                <button onClick={downloadMobileInvoice} className={` text-white bg-[#A1A3EF] px-[15px] py-[15px] text-[20px] font-semibold rounded-[9px]`}>
                    Download Invoice
                </button>
            </div>
        </div>
    )
}

export default PaymentInstallmentsInvoice